import { render, staticRenderFns } from "./PaymentList.vue?vue&type=template&id=51a703fc&scoped=true&"
import script from "./PaymentList.vue?vue&type=script&lang=js&"
export * from "./PaymentList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentList.vue?vue&type=style&index=0&id=51a703fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a703fc",
  null
  
)

export default component.exports